import React from 'react';

/** Loghi in `public/carriers/`, riconosciuti dal nome del vettore su NTS
 *  (come `clienti/spedizioni.py`: "TNT/FEDEX" è TNT). */
const LOGHI: [string, string, string[]][] = [
  ['TNT', '/carriers/tnt.png', ['TNT']],
  ['GLS', '/carriers/gls.png', ['GLS', 'G.L.S.']],
  ['BRT', '/carriers/brt.png', ['BRT', 'BARTOLINI']],
  ['SDA', '/carriers/sda.png', ['SDA']],
];

export function logoVettore(nome?: string | null): { nome: string; src: string } | null {
  const n = (nome || '').toUpperCase();
  const trovato = LOGHI.find(([, , chiavi]) => chiavi.some(k => n.includes(k)));
  return trovato ? { nome: trovato[0], src: trovato[1] } : null;
}

/** Logo e nome del vettore; solo il nome se non ne abbiamo il logo. */
export function VettoreLogo({ nome, className = 'h-5' }: { nome?: string | null; className?: string }) {
  if (!nome) return null;
  const logo = logoVettore(nome);
  return (
    <span className="inline-flex items-center gap-2" data-testid="vettore-logo">
      {logo && <img src={logo.src} alt={logo.nome} className={`${className} w-auto object-contain`} />}
      <span className="font-medium">{nome}</span>
    </span>
  );
}
